import { useState, useEffect } from "react";

export const BsEditableText = ({
	value,
	onChange,
	displayClass = "",
	inputClass = "form-control form-control-sm",
	placeholder="Unknown",
	fullWidth=false,
}) => {
	const [editing, setEditing] = useState(false);
	const [text, setText] = useState(value);

	const finishEdit = () => {
		setEditing(false);
		onChange(text);
	};

	useEffect(() => {
		setText(value);
	}, [value]);

	if (editing) {
		return (
			<input
				className={inputClass}
				autoFocus
				value={text}
				placeholder={placeholder}
				onChange={(e) => setText(e.target.value)}
				maxLength="100"
				onBlur={finishEdit}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						finishEdit();
					}
					if (e.key === "Escape") {
						setText(value); // 元に戻す
						setEditing(false);
					}
				}}
				style={{ width: fullWidth ? "100%" : "auto", display: 'inline' }}
			/>)
	}
	else {
		return (
			<span
				className={displayClass}
				onDoubleClick={() => setEditing(true)}
				style={{ minHeight: "1.5rem", cursor: "pointer" }}
			>
				{value || <span className="text-muted">{placeholder}</span>}
			</span>);
	}
};
